"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesPartnerLeadRequest = exports.SalesPartnerLeadData = exports.SalesPartnerChargeCardDetails = exports.SalesPartnerAddress = exports.SalesPartnerPersonalDetails = exports.SalesPartnerBusinessDetails = exports.SalesPartnerPaymentDetails = exports.ProductType = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ChargeStationDetails_1 = require("./ChargeStationDetails");
const ChargeCardType_1 = require("./enums/ChargeCardType");
const ChargingStationType_1 = require("./enums/ChargingStationType");
const ChargingStationColor_1 = require("./enums/ChargingStationColor");
const gender_1 = tslib_1.__importDefault(require("./enums/gender"));
var ProductType;
(function (ProductType) {
    ProductType["ChargeCard"] = "charge-card";
    ProductType["ChargingStation"] = "charge-station";
})(ProductType || (exports.ProductType = ProductType = {}));
class SalesPartnerPaymentDetails extends base_models_1.Serializable {
}
exports.SalesPartnerPaymentDetails = SalesPartnerPaymentDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIBAN)(),
    (0, base_models_1.Docs)({
        example: 'NL91ABNA0417164300',
        description: `Customer's IBAN number`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPaymentDetails.prototype, "iban", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'J. Jansen.', description: 'Account holder name' }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPaymentDetails.prototype, "accountHolder", void 0);
class SalesPartnerBusinessDetails extends base_models_1.Serializable {
}
exports.SalesPartnerBusinessDetails = SalesPartnerBusinessDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Essent B.V.', description: `Organization name` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerBusinessDetails.prototype, "organizationName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Length)(8),
    (0, base_models_1.Docs)({ example: '17115973', description: `Chamber of commerce number` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerBusinessDetails.prototype, "chamberOfCommerceNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'Deprecated, use chargeStationDetails' }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Boolean)
], SalesPartnerBusinessDetails.prototype, "interestedInReimbursement", void 0);
class SalesPartnerPersonalDetails extends base_models_1.Serializable {
}
exports.SalesPartnerPersonalDetails = SalesPartnerPersonalDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(gender_1.default),
    (0, base_models_1.Docs)({
        example: gender_1.default.OTHER,
        description: 'Gender of the customer to allow us to define how to address the customer',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "gender", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'W.B.', description: `Customer's initials` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "initials", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'van der', description: `Prefix to the customer's last name (Dutch)` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "prefix", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Boom', description: `Customer's last name` }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsPhoneNumber)('NL'),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: '06-12345789', description: 'Phone number' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEmail)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'w.boom@example.com', description: 'E-mail address' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "emailAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: '1990-12-31', description: 'Date of birth' }),
    (0, class_transformer_1.Expose)({ name: 'date_of_birth' }),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], SalesPartnerPersonalDetails.prototype, "dateofBirth", void 0);
class SalesPartnerAddress extends base_models_1.Serializable {
}
exports.SalesPartnerAddress = SalesPartnerAddress;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsPostalCode)('NL'),
    (0, base_models_1.Docs)({ example: '5211 AK', description: 'Postal code' }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerAddress.prototype, "postalCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[1-9]\d{0,9}$/),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: '4', description: 'House number' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerAddress.prototype, "houseNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(5),
    (0, class_transformer_1.Expose)({ name: 'house_number_extension' }),
    (0, base_models_1.Docs)({ example: 'A', description: 'Extension to house number' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerAddress.prototype, "houseNumberAddition", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Willemsplein', description: 'Street name' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerAddress.prototype, "street", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: `'s-Hertogenbosch`, description: 'City, town or village name' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerAddress.prototype, "city", void 0);
class SalesPartnerChargeCardDetails extends base_models_1.Serializable {
}
exports.SalesPartnerChargeCardDetails = SalesPartnerChargeCardDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(ChargeCardType_1.ChargeCardType),
    (0, base_models_1.Docs)({
        example: ChargeCardType_1.ChargeCardType.ChargeCard,
        description: `The type of the charge card`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerChargeCardDetails.prototype, "cardType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/NL-ESS-[CD]\d{8}-[A-Z]/),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'NL-ESS-D12345678-G', description: 'Charge card number' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerChargeCardDetails.prototype, "cardNumber", void 0);
class SalesPartnerLeadData extends base_models_1.Serializable {
}
exports.SalesPartnerLeadData = SalesPartnerLeadData;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'J. Jansen', description: 'Employee identifier' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "employee", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'EV', description: 'Channel identifier' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Essent', description: 'Service partner identifier' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "servicePartner", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Store 1', description: 'Store identifier' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "store", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'EV', description: 'Product type identifier' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "productType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Campaign', description: 'Campaign identifier' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "campaign", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Lease', description: 'Lead segment' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "leadSegment", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(36),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 'Essent', description: 'Invoice group' }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadData.prototype, "invoiceGroup", void 0);
class SalesPartnerLeadRequest extends base_models_1.Serializable {
}
exports.SalesPartnerLeadRequest = SalesPartnerLeadRequest;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '4be41f9d-1e9e-4d30-bb20-8a91c06ab37d',
        description: 'External partner ID, you will receive the value to include in this field',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadRequest.prototype, "externalPartnerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(ProductType),
    (0, base_models_1.Docs)({
        example: ProductType.ChargeCard,
        description: 'Product type',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadRequest.prototype, "productType", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => SalesPartnerPaymentDetails),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((o) => o.productType === ProductType.ChargeCard),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            iban: 'NL91ABNA0417164300',
            account_holder: 'E. Boom',
        },
        description: 'Customer payment details, required for charge station leads',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerPaymentDetails)
], SalesPartnerLeadRequest.prototype, "paymentDetails", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => SalesPartnerChargeCardDetails),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => o.productType === ProductType.ChargeCard),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            card_number: 'NL-ESS-C12345678-A',
            card_type: ChargeCardType_1.ChargeCardType.ChargeCard,
        },
        description: 'Charge card details, required for charge card leads',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerChargeCardDetails)
], SalesPartnerLeadRequest.prototype, "chargeCardDetails", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => ChargeStationDetails_1.EmobilityChargeStationDetails),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => o.productType === ProductType.ChargingStation),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            type: ChargingStationType_1.ChargingStationType.ProLine,
            color: ChargingStationColor_1.ChargingStationColor.White,
            fixedCable: false,
            interestedInReimbursement: true,
        },
        description: 'Charge point details',
    }),
    tslib_1.__metadata("design:type", ChargeStationDetails_1.EmobilityChargeStationDetails)
], SalesPartnerLeadRequest.prototype, "chargeStationDetails", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => SalesPartnerBusinessDetails),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            organization_name: 'Essent B.V.',
            chamber_of_commerce_number: '17115973',
        },
        description: 'Include if the customer is self employed and wants to purchase a charge point / card from his business',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerBusinessDetails)
], SalesPartnerLeadRequest.prototype, "businessDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => SalesPartnerPersonalDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            salutation: 'other',
            initials: 'E.',
            prefix: 'van der',
            last_name: 'Boom',
            phone_number: '0612345789',
            email_address: 'e.boom@gmail.com',
        },
        description: 'Personal details',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerPersonalDetails)
], SalesPartnerLeadRequest.prototype, "personalDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => SalesPartnerAddress),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            postal_code: '5211 AK',
            house_number: '4',
            house_number_extension: 'a',
            street: 'Willemsplein',
            city: "'s-Hertogenbosch",
        },
        description: 'Address for installation of charge point / delivery of charge card',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerAddress)
], SalesPartnerLeadRequest.prototype, "installationAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => SalesPartnerAddress),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            postal_code: '5211 AK',
            house_number: '4',
            house_number_extension: 'a',
            street: 'Willemsplein',
            city: "'s-Hertogenbosch",
        },
        description: 'Only include of the correspondence address for charge point cases is different than the installation address',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerAddress)
], SalesPartnerLeadRequest.prototype, "correspondenceAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => SalesPartnerLeadData),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            employee: 'J. Jansen',
            channel: 'EV',
            service_partner: 'Essent',
            store: 'Essent Zwolle',
            product_type: 'EV',
            campaign: 'EV Voorjaar campagne 2024',
            registration_date: '2021-06-01',
        },
        description: 'Additional data, expected values will be provided',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerLeadData)
], SalesPartnerLeadRequest.prototype, "requestContext", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(36),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: '4be41f9d-1e9e-4d30-bb20-8a91c06ab37d',
        description: 'Campaign ID, you will receive the value to include in this field',
    }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadRequest.prototype, "campaignId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: '1234567890',
        description: 'Lease contract number',
    }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadRequest.prototype, "leaseContractNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: 36,
        description: 'Lease contract duration',
    }),
    tslib_1.__metadata("design:type", Number)
], SalesPartnerLeadRequest.prototype, "leaseContractDuration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: '1234567890',
        description: 'Product ID',
    }),
    tslib_1.__metadata("design:type", String)
], SalesPartnerLeadRequest.prototype, "productId", void 0);
